// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-segment.secondSegment {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
}

ion-segment-button.vendordetailsSegment {
  flex: 1 1 50% !important;
  width: 50% !important;
  min-width: 50% !important;
  max-width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/flight-planning/route-plan/airports/airports.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,0BAAA;EACA,oBAAA;EACA,qBAAA;EACA,wBAAA;AACF;;AAEA;EACE,wBAAA;EACA,qBAAA;EACA,yBAAA;EACA,0BAAA;AACF","sourcesContent":["ion-segment.secondSegment {\n  width: 100% !important;\n  max-width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: flex !important;\n}\n\nion-segment-button.vendordetailsSegment {\n  flex: 1 1 50% !important;\n  width: 50% !important;\n  min-width: 50% !important;\n  max-width: 100% !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
